<div class="container-fluid">
<section>
	<header>
		<h1><span jhiTranslate="crop-settings-manager.title">Manage Crop settings</span>&nbsp;
            <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
		</h1>
	</header>
	<nav>
		<ul class="nav nav-tabs">
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['locations']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="crop-settings-manager.tabs.locations" data-test="locationsSettingsTab"></a>
			</li>
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['breeding-methods']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="crop-settings-manager.tabs.breeding-methods" data-test="breedingMethodsSettingsTab"></a>
			</li>
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['name-types']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="crop-settings-manager.tabs.name-type" data-test="nameTypesSettingsTab"></a>
			</li>
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['parameters']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="crop-settings-manager.tabs.parameters" data-test="parametersSettingsTab"></a>
			</li>
		</ul>
	</nav>
	<div class="tab-content p-3">
		<router-outlet></router-outlet>
	</div>
</section>
</div>
